<template>
  <label class="container-offre col-3">
    <input
      type="radio"
      :aria-checked="content.codePromo"
      :checked="isChecked"
      name="radio"
      :value="content.codePromo"
      @click="sendCodePromo"
      @keydown.space.prevent="sendCodePromo"
    />
    <span class="checkmark text-center my-0" v-html="content.libOffre" />
    <b-img-lazy
      :src="urlImage()"
      class="image-fond h-100 w-100"
      :alt="content.altImage ? content.altImage : ''"
    />
  </label>
</template>

<script>
import { bus } from '@/main';
import store from '@/store';

import { decodeHTMLText } from '@/helpers/StringHelpers';

export default {
  name: 'CarteOffreBienvenue',
  components: {},
  props: {
    content: { type: Object, required: true },
  },
  data() {
    return {
      hauteurTexte: 0,
    };
  },
  computed: {
    isChecked() {
      return store.state.compte.codePromo === this.content.codePromo ? 'checked' : '';
    },
  },
  updated() {
    if (this.isChecked === 'checked') {
      // Sauvegarde des infos de la promo sélectionnée ou par défaut dans le store
      this.storeInfoPromo();
    }
  },
  methods: {
    sendCodePromo() {
      this.storeInfoPromo();
      bus.$emit('codePromo', this.content.codePromo);
    },
    storeInfoPromo() {
      /**
       * Sauvegarde du libellé de la Promo dans le store
       * en préparation de la génération l'event GA4
       */
      store.commit('compte/SET_LIBELLE_PROMO', decodeHTMLText(this.content.libOffre));
    },
    urlImage() {
      return this.jel_getFichierSrc(this.content.image);
    },
  },
};
</script>

<style lang="scss" scoped>
/* Create a custom radio button */
.checkmark {
  display: grid;
  position: absolute;
  left: 0;
  top: 0;

  align-content: end;
  -webkit-align-content: end;
  background-color: #eee;
  padding: 0px 10px 10px;

  color: #ffffff;
  font-family: graphik_bold;
  font-size: 14px;
  letter-spacing: 0px;
  line-height: 17px;
  text-align: center;

  height: 150px;
  width: 200px;
  @media screen and (max-width: 420px) {
    font-family: graphik_semibold;
    height: 120px;
    width: 160px;
  }

  border-radius: 16px;
  -moz-border-radius: 16px;
  -webkit-border-radius: 16px;
  opacity: 1;
}

.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

.container-offre {
  display: inline-block;
  position: relative;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 150px;
  width: 200px;
  @media screen and (max-width: 420px) {
    height: 120px;
    width: 160px;
  }
  margin: 5px;
  padding: 0px !important;
  max-width: 240px !important;
  opacity: 1;
  ::v-deep img {
    border-radius: 16px;
    -moz-border-radius: 16px;
    -webkit-border-radius: 16px;
  }
}

.container-offre input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.container-offre:hover input ~ .checkmark {
  background-color: transparent;
  border: #ccc 6px solid;
  border-radius: 16px;
  -moz-border-radius: 16px;
  -webkit-border-radius: 16px;
  padding: 0px 7px 5px;
}

.container-offre input ~ .checkmark {
  background-color: transparent;
  border: #ccc 1px solid;
  border-radius: 16px;
  -moz-border-radius: 16px;
  -webkit-border-radius: 16px;
  font-weight: 400;
}

.container-offre input:checked ~ .checkmark {
  background-color: transparent;
  border: #ffffff 6px solid;
  border-radius: 16px;
  -moz-border-radius: 16px;
  -webkit-border-radius: 16px;
  padding: 0px 7px 5px;
}

.container-offre input:checked ~ .checkmark:after {
  display: block;
}

.container-offre:after {
  z-index: 10;
}

.degrade {
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 30%, #00034a 62.5%);
}

.flex-1 {
  flex: 1 1 0%;
}

.hauteur {
  padding: 0.5rem;
  @include media-breakpoint-down(md) {
    height: auto !important;
    padding: 0.5rem 0.75rem;
  }
}
</style>
